// $('#js-mvTop').vegas({
//   delay: 7000,
//   transition: 'flash',
//   ansitionDuration: 3000,
//   slides: [
//   {
//     src: '/image/top_mv_01.jpg',
//     copyTxt: 'さぁ、あなたのカーライフを<br>もっと便利で快適に。',
//     leadTxt: 'クルマのことは知らなくても、ドライバーは困らない時代。だからこそ、クルマの中身を知るほどに、いいことがたくさん。アプリとリンクするだけで、クルマとの新しい関係がはじまります。'
//   },
//   {
//     src: '/image/top_mv_02.jpg',
//     copyTxt: 'コネクタが一変させる、<br>クルマへの安心感とワクワク感。',
//     leadTxt: '新たなドライビング体験のトビラを開く鍵になるコネクタ。ワンタッチで簡単にセットするだけで、行き届いた情報が得られ、クルマをベストコンディションへ導いてくれる頼れる味方です。'
//   },
//   {
//     src: '/image/top_mv_03.jpg',
//     copyTxt: '手のひらにあなただけの<br>専属メカニックを。',
//     leadTxt: '記録した情報をもとにアプリがクルマを自動でヘルスチェック。エンジンやバッテリー、オイルなど、毎日の走行で変化するクルマの状態を分析して、最適なドライブをサポートします。'
//   },
//   {
//     src: '/image/top_mv_04.jpg',
//     copyTxt: 'ドライブする時間を<br>プレミアムな体験に変える。',
//     leadTxt: 'クルマとスマホをつなげば、あなたのカーライフはぐんと豊かで安全に。かしこく乗れば運転はもっと楽しくできる。きょうから差がつく、ワンランク上のドライバーになろう。'
//   }]
// });


var header = $('#js-header');

$(window).scroll(function() {
  if ($(this).scrollTop() > 0) {
    header.addClass('is-scrolled');
  } else {
    header.removeClass('is-scrolled');
  }
});

var menu = $('#js-tabMenu > *'),
  body = $('#js-tabBody'),
  content = body.children('.tabContent'),
  path = $('.js-detail-path');

$('#js-tabMenu>*:nth-child(1)').addClass('is-active');
// body.children().hide();
// body.children('.js-tabContent:first-child').show();
$('#detail-path-1').addClass('is-active');

var flg = true;

menu.click(function() {

  if(flg){
    //ボタンを一旦無効に
    flg = false;

    if($(this).hasClass('is-active')){
      flg = true;
    } else {
      // ナビの処理
      var num = $(this).parent().children().index(this);
      $(this).parent().each(function() {
        $('>li', this).removeClass('is-active').eq(num).addClass('is-active');
      });

      // 画像の処理
      $.when(
        $('#js-tabImg>*.is-active').removeClass('is-active').addClass('is-slideOut')
      ).done(function() {
        setTimeout(function(){
          $('#js-tabImg>*.is-slideOut').removeClass('is-slideOut');
        }, 600)
        setTimeout(function(){
          flg = true;
        }, 700)
      });
      $('#js-tabImg>*').eq(num).addClass('is-active');

      // テキストエリアの処理
      // body.children().hide().eq(num).fadeIn();
      body.children().removeClass('is-opened').eq(num).addClass('is-opened');

      // ラインの処理
      var num2 = num + 1;
      path.removeClass('is-active');
      $('#detail-path-' + num2).addClass('is-active');

    }

  } else {
    return false;
  }

});

$('a[href^="#"]').click(function () {
  var speed = 1000,
    href = $(this).attr('href'),
    target = $(href == '#' || href === "" ? 'html' : href),
    header = $('#js-header'),
    headerH = header.height(),
    gmoH = 38;

    if (window.matchMedia("(max-width:768px)").matches) {
      var position = target.offset().top - headerH;

      $('body,html').animate({
        scrollTop: position
      }, speed, 'easeOutQuint');
      return false;

    } else {
      var position = target.offset().top - headerH - gmoH;

      if(header.hasClass('is-scrolled')){
        $('body,html').animate({
          scrollTop: position
        }, speed, 'easeOutQuint');
        return false;
      } else {
        $('body,html').animate({
          scrollTop: position + 20
        }, speed, 'easeOutQuint');
        return false;
      }
    }

});

$(window).on('load', function () {
  var headerHeight = $('#js-header').height(),
      url = $(location).attr('href'),
      gmoH = 38;

  setTimeout(function () {

    if (url.indexOf("?id=") != -1) {
      var id = url.split("?id=");
      var $target = $('#' + id[id.length - 1]);
      if ($target.length) {


        var pos = $target.offset().top - headerHeight - gmoH;

        if (window.matchMedia("(max-width:768px)").matches) {
          var pos = $target.offset().top - headerHeight;

          $("html, body").animate({
            scrollTop: pos
          }, 1000, 'easeOutQuint');

        } else {
          var pos = $target.offset().top - headerHeight - gmoH;
          $("html, body").animate({
            scrollTop: pos + 20
          }, 1000, 'easeOutQuint');

        }
      }
    }
  }, 100);
});


// function tabSwitch() {
//   var menu = $('.tabMenu_item'),
//     body = $('.tabMenu').next('.tabBody'),
//     content = body.children('.tabContent');
//   $('.tabMenu_item:nth-child(1)').addClass('is-active');
//   body.children().hide();
//   body.children('.tabContent:first-child').show();
//   menu.click(function () {
//     var num = $(this).parent().children().index(this);
//     $(this).parent().each(function () {
//       $('>li', this).removeClass('is-active').eq(num).addClass('is-active');
//     });
//     $(this).parent().next().children().hide().eq(num).fadeIn();
//   });
// }



//////////////////
// WEBPACK FOOTER
// ./src/js/front.js
// module id = 13
// module chunks = 0